import script from "./MST44_060INS.vue?vue&type=script&setup=true&lang=js"
export * from "./MST44_060INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__